<template>
  <div class="container custom_container">
    <div class="custom_row row" v-if="tripType == 2">
      <div class="col-lg-9 col-md-12 col-sm-12 col-xs-12">
        <div class="row">
          <div class="b-left col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class="head row">
              <div id="title" class="col">
                <i class="icon-flight filter-icon"></i>
                <span>پرواز رفت </span>
              </div>
            </div>
            <br />
            <div class="flight container">
              <div v-if="selectedDeparture !== null" id="departure" class="row">
                <div style="display: contents">
                  <i class="icon mleft-5 icon-reply-1 filter-icon"></i>
                  <div class="mleft-5 segment">
                    <span>{{ selectedDeparture.originCity }}</span>

                    <span>{{ selectedDeparture.departureTime }}</span>
                  </div>
                  <div class="flight-segment">
                    <div id="duration"></div>
                    <div class="stop-diagram"></div>
                    <div id="textDate">
                      {{ selectedDeparture.departureDateTimeShamsiText }}
                    </div>
                  </div>

                  <div class="mleft-5 segment">
                    <span>{{ selectedDeparture.destinationCity }}</span>
                    <span>{{ selectedDeparture.arrivalTime }}</span>
                  </div>
                </div>
                <div style="display: contents">
                  <div id="action-icon">
                    <i class="action icon-eye-1 filter-icon"></i>
                    <img
                      id="airline-logo"
                      width="28"
                      height="28"
                      src="../../../public/img/airlines/zv.png"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="b-left col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class="head row">
              <div id="title" class="col">
                <i class="icon-flight filter-icon"></i>
                <span>پرواز برگشت</span>
              </div>
            </div>
            <br />
            <div class="flight container">
              <div v-if="selectedReturn !== null" id="departure" class="row">
                <div style="display: contents">
                  <i class="icon mleft-5 icon-forward-1 filter-icon"></i>
                  <div class="mleft-5 segment">
                    <span>{{ selectedReturn.originCity }}</span>

                    <span>{{ selectedReturn.departureTime }}</span>
                  </div>
                  <div class="flight-segment">
                    <div id="duration"></div>
                    <div class="stop-diagram"></div>
                    <div id="textDate">
                      {{ selectedReturn.departureDateTimeShamsiText }}
                    </div>
                  </div>

                  <div class="mleft-5 segment">
                    <span>{{ selectedReturn.destinationCity }}</span>
                    <span>{{ selectedReturn.arrivalTime }}</span>
                  </div>
                </div>
                <div style="display: contents">
                  <div id="action-icon">
                    <i class="action icon-eye-1 filter-icon"></i>
                    <img
                      id="airline-logo"
                      width="28"
                      height="28"
                      src="../../../public/img/airlines/zv.png"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
        <div class="total-pay">
          <div class="row">
            <span id="title">پرواز رفت + برگشت</span>
          </div>
          <div
            style="text-align: center"
            class="row"
            v-if="selectedDeparture !== null"
          >
            <span
              ><label id="price"> قیمت پرواز رفت: </label>
              {{ selectedDeparture.totalAdultFare | numFormat }} ريال</span
            >
          </div>
          <div class="row" v-if="selectedReturn !== null">
            <span
              ><label id="price"> قیمت پرواز برگشت: </label>
              {{ selectedReturn.totalAdultFare | numFormat }} ريال</span
            >
          </div>

          <div class="liner"></div>
          <div style="text-align: center" class="row">
            <span
              ><span style="font-size: 16px">کل هزینه سفر :</span>
              <label
                style="font-size: 14px; font-weight: bold; color: #08446a"
                >{{ totlaPrice | numFormat | rial }}</label
              ></span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="custom_row row" v-if="tripType == 1">
      <div class="container fixedElement">
        <div class="row">
          <div class="col-lg-9 col-md-12 col-sm-12 col-xs-12">
            <div class="row">
              <div class="b-left col-lg-12 col-md-6 col-sm-12 col-xs-12">
                <div>
                  <div id="title" class="col">
                    <i class="icon-flight filter-icon"></i>
                    <span> پرواز انتخاب شده</span>
                  </div>
                </div>
                <br />

                <div class="flight container">
                  <div id="departure" class="row">
                    <div style="display: contents">
                      <!-- <i class="icon mleft-5 icon-reply-1"></i> -->
                      <div class="mleft-5 segment-oneway">
                        <span>{{ selectedDeparture.originCity }}</span>

                        <span class="m-time">{{
                          selectedDeparture.departureTime
                        }}</span>
                      </div>
                      <div class="flight-segment-oneway m-time">
                        <div id="duration"></div>
                        <div class="stop-diagram"></div>
                        <div id="textDate">
                          {{ selectedDeparture.departureDateTimeShamsiText }}
                        </div>
                      </div>

                      <div class="mleft-5 segment-oneway">
                        <span>{{ selectedDeparture.destinationCity }}</span>
                        <span class="flight-segment-oneway m-time">{{
                          selectedDeparture.arrivalTime
                        }}</span>
                      </div>

                      <div class="mleft-5 segment-oneway">
                        <span>شماره پرواز</span>
                        <span class="flight-segment-oneway m-time">{{
                          selectedDeparture.flightNumber
                        }}</span>
                      </div>
                    </div>

                    <div style="display: contents">
                      <div id="action-icon">
                        <!-- <i class="action icon-eye-1"></i> -->
                        <img
                          id="airline-logo"
                          width="38"
                          height="38"
                          src="../../../public/img/airlines/zv.png"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
            <div class="total-pay">
              <div class="row">
                <span id="title">پرواز </span>
              </div>

              <div class="liner"></div>
              <div style="text-align: center;     margin-top:15px;" class="row">
                <span
                  ><span style="font-size: 16px"> هزینه سفر :</span>

                  <label
                    style="font-size: 14px; font-weight: bold; color: #08446a"
                  >
                    ريال {{ totlaPrice | numFormat }}</label
                  ></span
                >
              </div>
            </div>
            <!-- <SKLTotalPrice class="total-pay" /> -->
          </div>
        </div>

        <div class="subtitle row">
          <div class="col">
            به هنگام رزرو پرواز و هتل در آن واحد، تا 15% صرفه جویی کنید!
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "FlightSummery",
  props: {
    selectedDeparture: Object,
    selectedReturn: Object,
  },
  data: () => ({
    totlaPrice: 0,
    params: {},
    tripType: 1,
  }),
  created() {
    this.params = this.$route.query;
    this.tripType = parseInt(this.params.tripType);
    this.calcTotlaPrice();
  },
  methods: {
    calcTotlaPrice() {
      if (this.tripType == 2) {
        this.totlaPrice =
          parseInt(this.selectedDeparture.totalAdultFare) +
          parseInt(this.selectedReturn.totalAdultFare);
      } else if (this.tripType == 1) {
        this.totlaPrice = parseInt(this.selectedDeparture.totalAdultFare);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.liner {
  border: 1px solid #eeeeee;
  margin-bottom: 8px;
  margin-top: 5px;
}
.change-flight {
  margin-right: 20px !important;
  margin-top: 10px !important;
  padding-left: 0px !important;
  color: #0a6c9f;
  cursor: pointer;
  display: contents;
}
.flight-segment {
  text-align: center;
  color: #08446a;
  font-size: 12px;
  width: 170px;
}
.flight-segment-oneway {
  text-align: center !important;
  color: #08446a !important;
  width: 170px !important;
  margin-bottom: 20px;
}

#airline-logo {
  margin-top: -6px !important;
}
.title span #price {
  font-weight: bold;
}
.total-pay {
  padding: 20px 40px 14px 40px;
}
.total-pay a {
  margin-top: 22px;
}

.total-pay span {
  margin: auto;
}
.total-pay #title {
  margin: auto;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}
#hotel-detail {
  line-height: 24px;
  font-size: 13px;
  padding: 0px 2px 0px 0px;
}

#hotel-title {
  font-weight: bold;
  font-size: 13px;
  margin-bottom: 11px;
  // margin-top: 14px;
}
.hotel #hotel-image {
  border-radius: 8px;
  margin-left: 5px;
}
.stop-diagram {
  height: 1px;
  background: #c7c1c1;
  width: 170px;
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 15px;
  margin-right: 15px;
}

.mleft-5 {
  margin-left: 5px;
}
.head {
  margin: 0px -3px 0px -8px;
  padding-top: 6px;
  border-radius: 5px;
}
.head-border {
  border-top: 2px #fcbe2f solid;
}
.head #title {
  font-size: 15px;
  color: #5c666b;
}
.head #change {
  text-align: left;
  color: #0a6c9f;
  cursor: pointer;
  font-size: 15px;
  margin-left: 5px;
}
.custom_row {
  border-top: 2px #00c3e1 solid;

  margin: 3px 0px 3px 0px;
  padding-top: 5px;
}
.custom_container {
  background-color: rgb(255, 255, 255);
  top: 0;
  width: 100%;
  z-index: 100;
  padding: 5px 10px 5px 10px;
  border-radius: 20px;
  margin-bottom: 20px;
  box-shadow: 3px 3px 3px 3px #aaaaaa4a;
}
.flight {
  padding: 0px 0px 0px 0px;
}
.flight #departure {
  margin: 10px 0 10px 0;
}
.flight #departure .icon {
  margin-top: auto;
  margin-bottom: auto;
  font-size: 15px;
  color: #867b7b;
}
.flight #departure #action-icon {
  margin-top: auto;
  margin-bottom: auto;
  font-size: 18px;
  color: #8da6b3;
  margin-right: 15px;
}
.action:hover {
  cursor: pointer;
  // font-size: 20px;
}
.segment {
  text-align: center;
  display: grid;
}

.segment-oneway {
  text-align: center;
  display: grid;
  width: 20% !important;
  font-size: 16px !important;
}
.b-left {
  border-left: 1px #e2e2e2 solid;
}
.subtitle {
  border-top: 1px #c5c5c5 solid;
  margin-left: 20px;
  margin-right: 20px;
  padding: 10px 1px 10px 1px;
}

.subtitle-display {
  display: none;
}
.subtitle div {
  text-align: left;
  color: #265215;
  font-size: 15px;
}
.m-time {
  margin-top: 30px !important;
}
</style>